import { render } from "./EditFarmerModal2.vue?vue&type=template&id=6875afbd&scoped=true"
import script from "./EditFarmerModal2.vue?vue&type=script&lang=js"
export * from "./EditFarmerModal2.vue?vue&type=script&lang=js"

import "./EditFarmerModal2.vue?vue&type=style&index=0&id=6875afbd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6875afbd"]])

export default __exports__